import log from 'loglevel';
const href = window?.location?.href;
const domain = href?.substring(0, href.lastIndexOf('/')) + '/';

const siteTier = process.env.REACT_APP_TIER
  ? process.env.REACT_APP_TIER
  : 'stg';

/*
 * Launch Darkly client side ids
 * */
const launchDarklyClient = {
  qa: '5d0876473eac5f076a7f3c45', // not in use
  local: '5d087647dfee14076bab4df3',
  stg: '5d0876475a188c077d3d6440', //uhm's dev, int, stg
  prod: '5d087646dfee14076bab4def',
};

const dynatraceRumUrl = (tier) => {
  // local and Dev UA tiers intentionally do not map to anything, we do not want to add RUM there.

  // skip localhost regardless of tier value
  if (domain.includes('localhost')) {
    return {dynatraceRumScript: null};
  }

  switch (tier) {
    case 'prd':
      return {
        dynatraceRumScript:
          'https://js-cdn.dynatrace.com/jstag/1672bab6729/bf86358stq/d70b81b2557d1bdb_complete.js',
      };
    case 'int':
    case 'stg':
      return {
        dynatraceRumScript:
          'https://js-cdn.dynatrace.com/jstag/1672bab6729/bf11536igv/4920f28a847bf549_complete.js',
      };
    default:
      return {
        dynatraceRumScript: null,
      };
  }
};

/*
 * Site URLs
 * */

/*Account URLs*/
const accountPortalUrls = (tier) => {
  switch (tier) {
    case 'prd':
      return {
        caseManagementPortal:
          'https://autodesk.secure.force.com/Customer/apex/Case_CustomerPortalLandingPage#view/CaseManagement_ViewCases/',
      };
    case 'dev':
      return {
        caseManagementPortal:
          'https://adsksfstg-autodesk.cs12.force.com/Customer/apex/Case_CustomerPortalLandingPage#view/CaseManagement_ViewCases/',
      };
    default:
      return {
        caseManagementPortal:
          'https://adsksfstg-autodesk.cs12.force.com/Customer/apex/Case_CustomerPortalLandingPage#view/CaseManagement_ViewCases/',
      };
  }
};

let siteTierConfig;

if (siteTier === 'prd') {
  log.setLevel('error');
  siteTierConfig = {
    // PRD
    //sitesConfigUrl: 'https://uhm.autodesk.com/sites.config.json',
    srcUrlForInProduct:
      'https://app.digital-help-prd.autodesk.com/universal-help/current/index.html',
    sitesConfigUrl:
      'https://api.digital-help-prd.autodesk.com/services/v1/sites-config',
    linkToMappingUrl:
      'https://api.digital-help-prd.autodesk.com/static/uhm-workflows/current/workflows/linkToMapping.json',
    experimentSitesConfigUrl:
      'https://api.digital-help-prd.autodesk.com/static/uhm-workflows/current/experiments',
    oxygenTier: 'production',
    oxygenCallbackUrl: domain + 'oxygen_openid_response.html',
    tealiumScript: 'https://tags.tiqcdn.com/utag/autodesk/uhm/prod/utag.js',
    productsApi:
      'https://beehive.autodesk.com/ontology/v1/rest/allprodrelease/json?order=asc',
    adpConfigs: {
      appId: 'uhm',
      env: 'production',
      serviceUrl: 'https://akn.analytics.autodesk.com',
      apiKey: process.env.REACT_APP_UHM_ADP_API_KEY_PRD,
      signWith: process.env.REACT_APP_UHM_ADP_SIGNIN_WITH_PRD,
    },
    cmtVar: '1014180', // Setup in Salesforce Campagin Management Tool
    beehiveCaasKeyApi:
      'https://beehive.autodesk.com/community/service/rest/caas/resource/caasdoc2?',
    beehiveSuggestApi:
      'https://beehive.autodesk.com/toolkit/service/rest/resource/taxonomy3/suggest',
    skillsModelApi:
      'https://api.digital-help-prd.autodesk.com/services/v2/skills',
    ldClientID: launchDarklyClient.prod,
    eteSessionLambdaUrl:
      'https://udklrynjp5.execute-api.us-east-1.amazonaws.com/PROD',
    ...accountPortalUrls(siteTier),
    ADNSupportPage: 'https://www.autodesk.com/developer-network/open',
    ...dynatraceRumUrl(siteTier)
  };
} else if (siteTier === 'dev') {
  log.setLevel('debug');
  // DEV

  siteTierConfig = {
    //sitesConfigUrl: 'https://uhm-dev.autodesk.com/sites.config.json',
    srcUrlForInProduct:
      'https://app.digital-help-dev.autodesk.com/universal-help/current/index.html',
    sitesConfigUrl:
      'https://api.digital-help-dev.autodesk.com/services/v1/sites-config',
    linkToMappingUrl:
      'https://api.digital-help-dev.autodesk.com/static/uhm-workflows/current/workflows/linkToMapping.json',
    experimentSitesConfigUrl:
      'https://api.digital-help-dev.autodesk.com/static/uhm-workflows/current/experiments',
    oxygenTier: 'staging',
    oxygenCallbackUrl: domain + 'oxygen_openid_response.html',
    tealiumScript: 'https://tags.tiqcdn.com/utag/autodesk/uhm-qa/qa/utag.js',
    productsApi:
      'https://beehive-stage.autodesk.com/ontology/v1/rest/allprodrelease/json?order=asc',
    adpConfigs: {
      appId: 'uhm',
      env: 'staging',
      serviceUrl: 'https://akn.analytics-staging.autodesk.com',
      apiKey: process.env.REACT_APP_UHM_ADP_API_KEY_STG,
      signWith: process.env.REACT_APP_UHM_ADP_SIGNIN_WITH_STG,
    },
    cmtVar: '1014180', // Setup in Salesforce Campagin Management Tool
    beehiveCaasKeyApi:
      'https://beehive-stage.autodesk.com/community/service/rest/caas/resource/caasdoc2?',
    beehiveSuggestApi:
      'https://beehive-stage.autodesk.com/toolkit/service/rest/resource/taxonomy3/suggest',
    skillsModelApi:
      'https://api.digital-help-dev.autodesk.com/services/v2/skills',
    ldClientID: launchDarklyClient.stg,
    eteSessionLambdaUrl:
      'https://6zqbylrbda.execute-api.us-east-1.amazonaws.com/STAGE',
    ...accountPortalUrls(siteTier),
    ADNSupportPage: 'https://www.autodesk.com/developer-network/open',
    ...dynatraceRumUrl(siteTier)
  };
} else {
  // Local,INT and STG
  log.setLevel('debug');

  siteTierConfig = {
    //sitesConfigUrl: 'https://uhm-stg.autodesk.com/sites.config.json',
    srcUrlForInProduct:
      'https://app.digital-help-stg.autodesk.com/universal-help/current/index.html',
    sitesConfigUrl:
      'https://api.digital-help-stg.autodesk.com/services/v1/sites-config',
    linkToMappingUrl:
      'https://api.digital-help-stg.autodesk.com/static/uhm-workflows/current/workflows/linkToMapping.json',
    experimentSitesConfigUrl:
      'https://api.digital-help-stg.autodesk.com/static/uhm-workflows/current/experiments',
    oxygenTier: 'staging',
    oxygenCallbackUrl: domain + 'oxygen_openid_response.html',
    tealiumScript: 'https://tags.tiqcdn.com/utag/autodesk/uhm-qa/qa/utag.js',
    productsApi:
      'https://beehive-stage.autodesk.com/ontology/v1/rest/allprodrelease/json?order=asc',
    adpConfigs: {
      appId: 'uhm',
      env: 'staging',
      serviceUrl: 'https://akn.analytics-staging.autodesk.com',
      apiKey: process.env.REACT_APP_UHM_ADP_API_KEY_STG,
      signWith: process.env.REACT_APP_UHM_ADP_SIGNIN_WITH_STG,
      // TODO: Added keys here for local testing, remove and uncomment 2 lines above
      // apiKey: 'e796e8ec4046484b90e1595d315aa85d',
      // signWith: 'b5d84be8-6b01-4093-adbd-aa89c24ee514',
    },
    cmtVar: '1014180', // Setup in Salesforce Campagin Management Tool
    beehiveCaasKeyApi:
      'https://beehive-stage.autodesk.com/community/service/rest/caas/resource/caasdoc2?',
    beehiveSuggestApi:
      'https://beehive-stage.autodesk.com/toolkit/service/rest/resource/taxonomy3/suggest',
    skillsModelApi:
      'https://api.digital-help-stg.autodesk.com/services/v2/skills',
      ldClientID: typeof siteTier === 'undefined' || siteTier === 'local'
        ? launchDarklyClient.local
        : launchDarklyClient.stg,
    eteSessionLambdaUrl:
      'https://6zqbylrbda.execute-api.us-east-1.amazonaws.com/STAGE',
    ...accountPortalUrls(siteTier),
    ADNSupportPage: 'https://www.autodesk.com/developer-network/open',
    ...dynatraceRumUrl(siteTier)
  };
}

let siteConfigFallbacks = (tier) => {
  if (tier === 'prd') {
    return {
      workflowJson:
        'https://api.digital-help-prd.autodesk.com/static/uhm-workflows/current/workflows/en_US_generic.json',
      pageTitle: 'Fallback Page',
      utmSource: 'local-uhm',
      language: 'en_US',
      country: 'US',
      product: 'ACD',
      version: '',
      appTier: 'prd',
      origin: 'Corporate Website',
      showLangFallbackMsg: false,
    };
  } else if (tier === 'dev') {
    return {
      workflowJson:
        'https://api.digital-help-stg.autodesk.com/static/uhm-workflows/current/workflows/en_US_generic.json',
      pageTitle: 'Fallback Page',
      utmSource: 'local-uhm',
      language: 'en_US',
      country: 'US',
      product: 'ACD',
      version: '',
      appTier: 'dev',
      origin: 'Corporate Website',
      showLangFallbackMsg: false,
    };
  } else {
    return {
      workflowJson:
        'https://api.digital-help-stg.autodesk.com/static/uhm-workflows/current/workflows/en_US_generic.json',
      pageTitle: 'Fallback Page',
      utmSource: 'local-uhm',
      language: 'en_US',
      country: 'US',
      product: 'ACD',
      version: '',
      appTier: 'stg',
      origin: 'Corporate Website',
      showLangFallbackMsg: false,
    };
  }
};

/*
 * SKILLS
 * */

// convert Skills to Contact Type
const getContactTypefromSkill = (s, sfdcType) => {
  if (sfdcType && sfdcType === 'Certification Support') {
    return 'certification';
  }
    switch (s) {
      case 'PRE':
      case 'IA':
      case 'NX':
      case 'RA':
        return 'clientServices';
      case 'IL':
        return 'installationLicensing';
      case 'TS':
        return 'support';
      default:
        return 'clientServices';
    }
};

// branch level after which to show topic not listing
const branchCuttoffLevel = 3;

/*
 * Actions
 * */
// Constants, For Actions
const CONTACT_OPTIONS = 'CONTACT_OPTIONS';
const CONTACT_OPTION_CASE = 'CONTACT_OPTION_CASE';
const DISAMBIGUATION_QUESTIONS = 'DISAMBIGUATION_QUESTIONS';
const CONTENT_SUGGESTION = 'CONTENT_SUGGESTION';
const CAAS_CONTENT = 'CAAS_CONTENT';
const AVA = 'AVA';
const LINKS = 'LINKS';
const FAIL_SCREEN = 'FAIL_SCREEN';
const CONTACT_OPTION_SCHEDULER = 'CONTACT_OPTION_SCHEDULER';
const actionsMap = {
  ava: AVA,
  caas: CAAS_CONTENT,
  links: LINKS,
  content_suggestion: CONTENT_SUGGESTION,
  contact_options: CONTACT_OPTIONS,
};

const analyticsLabelMap = {
  links: 'Top Solutions',
  caas: 'Pupose Built Content',
  content_suggestion: 'Content Suggestion',
  ava: 'AVA',
};

// formatting is lang_COUNTRY using ISO 2 letter codes.
// IMPORTANT to ensure this formatting
// available languages
const enabledLangsAndCountry = [
  'en_US',
  'de_DE',
  'en_MY',
  'en_AU',
  'zh_CN',
  'en_HK',
  'en_IN',
  'ja_JP',
  'ko_KR',
  'en_NZ',
  'en_SG',
  'zh_TW',
  'fr_BE',
  'nl_BE',
  'cs_CZ',
  'da_DK',
  'en_NL',
  'fr_FR',
  'fi_FI',
  'hu_HU',
  'it_IT',
  'en_AE',
  'nl_NL',
  'nb_NO',
  'pl_PL',
  'pt_PT',
  'ru_RU',
  'en_ZA',
  'es_ES',
  'sv_SE',
  'de_CH',
  'fr_CH',
  'it_CH',
  'tr_TR',
  'en_GB',
  'pt_BR',
  'en_CA',
  'fr_CA',
  'es_MX',
  'es_LA',
];
const contentSuggestionLangs = ['en_US'];

// oxygen language parameters
const oxygenLanguageMap = (currentLang) => {
  switch (currentLang) {
    case 'de_DE':
      return 'de';
    default:
      return 'en';
  }
};

//UHM language -> Beehive Lang code mapping
const beehiveLangMap = {
  cs_CZ: 'CSY',
  da_DK: 'DAN',
  de_CH: 'DEU',
  de_DE: 'DEU',
  en_AE: 'ENU',
  en_AU: 'ENU', //TODO: Supposed to be 'ENG', but we are using 'ENU' for April Release, As translations not ready
  en_CA: 'ENU',
  en_GB: 'ENU', //TODO: Supposed to be 'ENG', but we are using 'ENU' for April Release, As translations not ready
  en_HK: 'ENU',
  en_IN: 'ENU', //TODO: Supposed to be 'ENG', but we are using 'ENU' for April Release, As translations not ready
  en_MY: 'ENU',
  en_NL: 'ENU',
  en_NZ: 'ENU', //TODO: Supposed to be 'ENG', but we are using 'ENU' for April Release, As translations not ready
  en_SG: 'ENU',
  en_US: 'ENU',
  en_ZA: 'ENU',
  es_ES: 'ESP',
  es_MX: 'ESM',
  es_LA: 'ESM',
  fi_FI: 'FIN',
  fr_BE: 'FRA',
  fr_CA: 'FRC',
  fr_CH: 'FRA',
  fr_FR: 'FRA',
  hu_HU: 'HUN',
  it_CH: 'ITA',
  it_IT: 'ITA',
  ja_JP: 'JPN',
  ko_KR: 'KOR',
  nb_NO: 'NOR',
  nl_BE: 'NLD',
  nl_NL: 'NLD',
  pl_PL: 'PLK',
  pt_BR: 'PTB',
  pt_PT: 'PTG',
  ru_RU: 'RUS',
  sv_SE: 'SWE',
  tr_TR: 'TUR',
  zh_CN: 'CHS',
  zh_TW: 'CHT',
};
//UHM language -> AVA Lang code mapping
const avaLangMap = {
  cs_CZ: 'cs',
  da_DK: 'en', // No AVA Equivalent. Fallback to en
  de_CH: 'de',
  de_DE: 'de',
  en_AE: 'en',
  en_AU: 'en',
  en_CA: 'en',
  en_GB: 'en',
  en_HK: 'en',
  en_IN: 'en',
  en_MY: 'en',
  en_NL: 'en',
  en_NZ: 'en',
  en_SG: 'en',
  en_US: 'en',
  en_ZA: 'en',
  es_ES: 'es',
  es_MX: 'es',
  es_LA: 'es',
  fi_FI: 'fi', // No AVA Equivalent. Fallback to en
  fr_BE: 'fr',
  fr_CA: 'fr',
  fr_CH: 'fr',
  fr_FR: 'fr',
  hu_HU: 'hu',
  it_CH: 'it',
  it_IT: 'it',
  ja_JP: 'ja',
  ko_KR: 'ko',
  nb_NO: 'en', // No AVA Equivalent. Fallback to en
  nl_BE: 'en', // No AVA Equivalent. Fallback to en
  nl_NL: 'en', // No AVA Equivalent. Fallback to en
  pl_PL: 'pl',
  pt_BR: 'pt_BR',
  pt_PT: 'pt_BR',
  ru_RU: 'ru',
  sv_SE: 'en', // No AVA Equivalent. Fallback to en
  tr_TR: 'en', // No AVA Equivalent. Fallback to en
  zh_CN: 'zh_CN',
  zh_TW: 'zh_TW',
};

const contentSuggestionLangMap = {
  en_MY: 'ENU',
  en_AU: 'ENU',
  zh_CN: 'CHS',
  en_HK: 'ENU',
  en_IN: 'ENU',
  ja_JP: 'JPN',
  ko_KR: 'KOR',
  en_NZ: 'ENU',
  en_SG: 'ENU',
  zh_TW: 'CHS',
  fr_BE: 'FRA',
  nl_BE: 'ENU',
  cs_CZ: 'ENU',
  de_DE: 'DEU',
  da_DK: 'ENU',
  en_NL: 'ENU',
  fr_FR: 'FRA',
  fi_FI: 'ENU',
  hu_HU: 'ENU',
  it_IT: 'ITA',
  en_AE: 'ENU',
  nl_NL: 'ENU',
  nb_NO: 'ENU',
  pl_PL: 'ENU',
  pt_PT: 'PTB',
  ru_RU: 'RUS',
  en_ZA: 'ENU',
  es_ES: 'ESP',
  sv_SE: 'ENU',
  de_CH: 'DEU',
  fr_CH: 'FRA',
  it_CH: 'ITA',
  tr_TR: 'ENU',
  en_GB: 'ENU',
  pt_BR: 'PTB',
  en_CA: 'ENU',
  fr_CA: 'FRA',
  es_LA: 'ESP',
  es_MX: 'ESP',
  en_US: 'ENU',
};

// const noSupportProducts = ['TAKEOFF', 'BUILD', 'DOCS'];
const noSupportProducts = [
  {'name': 'TAKEOFF', 'plc': 'TAKEOFF', 'skills': ['TS']},
  {'name': 'BUILD', 'plc': 'BUILD', 'skills': ['TS']},
  {'name': 'DOCS', 'plc': 'DOCS', 'skills': ['TS']},
  {'name': 'FORMA', 'plc': 'SPCMKR', 'skills': ['TS', 'IL']},
  {'name': 'PRODSMART', 'plc': 'PRDSMRT', 'skills': ['TS', 'IL']},
  {'name': 'FUSION OPERATIONS', 'plc': 'FUSADMIN', 'skills': ['TS', 'IL']},
  {name: 'FLEXSIM', plc: 'FLXSIM', skills: ['TS', 'IL']},
];

const productDoesNotSupportContentSuggestion = (product, skill) => {
  // noSupportProducts.includes(product) && skill === 'TS';
  let found = noSupportProducts.find(({plc}) => plc === product);
  return ((found && found?.skills?.includes(skill)) || false)
}


const noInsideSalesCountries = [
  'en_MY',
  'en_SG',
  'zh_TW',
  'ko_KR',
  'en_HK',
  'pt_BR',
  'es_LA',
  'es_MX',
];

const collectionProductsMap = {
  AECCOL: 'Architecture, Engineering & Construction Collection',
  PDCOLL: 'Product Design & Manufacturing Collection',
  MECOLL: 'Media & Entertainment Collection',
};
/*
 * Public Keys
 * */
let key = process.env.REACT_APP_UHM_CONTACT_PRD_KEY;
if (process.env.REACT_APP_TIER !== 'prd') {
  key = process.env.REACT_APP_UHM_CONTACT_DEV_KEY;
}
const callbackKey = key;

const leadCreationKey =
  process.env.REACT_APP_TIER === 'stg'
    ? process.env.REACT_APP_UHM_LEAD_CREATION_STG
    : process.env.REACT_APP_UHM_LEAD_CREATION_PRD;

// set up PAT, client ID, and client secret for OAuth2 test automation
// add values to ~/.bash_profile for local development

// if an invalid entitlement is given, return gold subscriber
const getPATbyEntitlement = (entitlement) => {
  const entitlementCode = (typeof(entitlement) === 'string' && entitlement !== '') ? entitlement.toUpperCase() : 'GOLD_SUBSCRIBER'
  const tier = process.env?.REACT_APP_TIER === 'prd' ? 'PRD' : 'STG'
  const PATCredentialsID = `REACT_APP_UA_PAT_${entitlementCode}_${tier}`
  if (process.env[PATCredentialsID]) {
    return process.env[PATCredentialsID]
  } else {
    console.error("Unsupported PAT for tier and entitlement: ", tier, entitlement)
    return process.env[`REACT_APP_UA_PAT_GOLD_SUBSCRIBER_${tier}`]
  }
}

const PATClientID =
    process.env.REACT_APP_TIER === 'prd'
    ? process.env.REACT_APP_UA_PAT_CLIENT_ID_PRD
    : process.env.REACT_APP_UA_PAT_CLIENT_ID_STG


const PATClientSecret =
    process.env.REACT_APP_TIER === 'prd'
    ? process.env.REACT_APP_UA_PAT_CLIENT_SECRET_PRD
    : process.env.REACT_APP_UA_PAT_CLIENT_SECRET_STG

const analyticsAva = {
  m2s_single_success: {
    linkTitle: 'M2S single Success',
  },
  m2s_multi_success: {
    linkTitle: 'M2S multi Success',
  },
  download_started: {
    linkTitle: 'Download',
  },
  helpful_solution: {
    linkTitle: "Thanks, I'm done",
  },
  find_user: {
    linkTitle: 'Find a user',
  },
  learn_more_user_management: {
    linkTitle: 'Learn more about user management and classic user management',
  },
  user_found: {
    //This object needs to account for two callbacks to UHM (onClose, onReload)
    linkTitle: 'User found',
  },
  existing_subscriber: {
    linkTitle: 'I am an existing subscriber',
  },
  'existing-subscriber-end': {
    linkTitle: 'I am an existing subscriber - end',
  },
  student_or_educator: {
    linkTitle: 'I am a student or educator',
  },
  find_another_product: {
    linkTitle: 'Find another product',
  },
  midflow_escalation: {
    linkTitle: 'Not what you were expecting?',
  },
  solution_not_hepful: {
    linkTitle: 'Talk to a support agent',
  },
  contact_support: {
    linkTitle: 'Talk to a support agent',
  },
};

// EteRouter URL
export const eteRouterLambdaUrl = {
  dev: 'https://xy1e932aff.execute-api.us-east-1.amazonaws.com/STAGE',
  stg: 'https://xy1e932aff.execute-api.us-east-1.amazonaws.com/STAGE',
  prd: 'https://ppau67awad.execute-api.us-east-1.amazonaws.com/PROD'
};

const END_CHAT_FEEDBACK_URL =
  process.env.REACT_APP_TIER === 'prd'
    ? 'https://autodesk.co1.qualtrics.com/jfe/form/SV_aWd9zzdU4we7QTr'
    : 'https://autodesk.co1.qualtrics.com/SE/?SID=SV_6fBIznxPaF2e15Y'
const orchestrationAPIKey =
  process.env.REACT_APP_TIER === 'prd'
    ? process.env.REACT_APP_UHM_ORCHESTRATION_KEY_PRD
    : process.env.REACT_APP_UHM_ORCHESTRATION_KEY_STG;

export {
  domain,
  branchCuttoffLevel,
  CONTACT_OPTIONS,
  CONTACT_OPTION_CASE,
  DISAMBIGUATION_QUESTIONS,
  CONTENT_SUGGESTION,
  CAAS_CONTENT,
  AVA,
  LINKS,
  FAIL_SCREEN,
  CONTACT_OPTION_SCHEDULER,
  END_CHAT_FEEDBACK_URL,
  actionsMap,
  analyticsLabelMap,
  enabledLangsAndCountry,
  contentSuggestionLangs,
  oxygenLanguageMap,
  productDoesNotSupportContentSuggestion,
  siteTierConfig,
  siteConfigFallbacks,
  siteTier,
  getContactTypefromSkill,
  callbackKey,
  beehiveLangMap,
  contentSuggestionLangMap,
  avaLangMap,
  noInsideSalesCountries,
  noSupportProducts,
  collectionProductsMap,
  analyticsAva,
  leadCreationKey,
  PATClientID,
  PATClientSecret,
  getPATbyEntitlement,
  orchestrationAPIKey,
};
